// extracted by mini-css-extract-plugin
export default {"modalContent":"TeacherClassModal_modalContent__yXA+B","notAvailable":"TeacherClassModal_notAvailable__mg1cE"};